import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormsModule,
  FormGroup,
  FormBuilder,
  AbstractControl,
  Validators
} from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Vendor } from '../../../models/vendor.model';
import { CommonSharedModule } from '../../common/shared.module';
import { ValidationService } from '../../services/validation.service';
import { VendorService } from '../../services/vendor.service';

@Component({
  selector: 'app-add-vendor',
  templateUrl: './add-vendor.component.html',
  styleUrls: ['./add-vendor.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, CommonSharedModule]
})
export class AddVendorComponent {
  addVendorForm!: FormGroup;
  isDialogOpen!: boolean;
  inlineMessage!: any[];
  isLoading = false;

  constructor(
    private formBuilder: FormBuilder,
    private vendorService: VendorService,
    private validationService: ValidationService
  ) {
    this.OnFormGroup();
  }

  get addVendorFormControls(): Record<string, AbstractControl> {
    return this.addVendorForm.controls;
  }

  OnFormGroup() {
    this.addVendorForm = this.formBuilder.group({
      vendorIdField: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(15),
          Validators.pattern('^[0-9]*$'),
          this.validationService.isInteger32
        ]
      ],
      payeeNameField: ['', [Validators.required]],
      payeeEmailField: ['', [Validators.required]],
      payeeEmailDomainField: ['']
    });
  }

  showDialog() {
    this.isDialogOpen = true;
  }

  closeDialog() {
    this.isDialogOpen = false;
    this.addVendorForm.reset();
    this.inlineMessage = [];
  }

  onSubmitVendorInformation() {
    this.isLoading = true;

    const vendorInfo: Vendor = {
      vendorId: this.addVendorForm.controls['vendorIdField'].value,
      payeeName: this.addVendorForm.controls['payeeNameField'].value,
      payeeEmail: this.addVendorForm.controls['payeeEmailField'].value,
      payeeEmailDomain:
        this.addVendorForm.controls['payeeEmailDomainField'].value
    };

    this.vendorService.AddVendorInformation(vendorInfo).subscribe(
      () => {
        this.showMessage('Successfully Added Vendor Information', 'success');
        this.addVendorForm.reset();
        this.isLoading = false;
      },
      errorResponse => {
        this.showMessage(errorResponse.error.errorInfo, 'error');
        this.isLoading = false;
      }
    );
  }

  showMessage(message: string, severity: string) {
    this.inlineMessage = [{ severity: severity, detail: message }];
  }
}
